module.exports = __webpack_public_path__ + "img/Trophy Cup Table39.c3949631.jpg";